import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const TABS = [
  {
    id: 'applications',
    label: 'Applications',
    to: '/admin/enrollments',
  },
  {
    id: 'payment-verification',
    label: 'Payment Verification',
    to: '/admin/enrollments/payment-verification',
  },
]

/**
 * Shared tab strip for Manage Enrollments.
 * Admin / campus admin / superuser see both tabs; finance-only sees Payment Verification only.
 */
function EnrollmentManagementTabs({ active }) {
  const navigate = useNavigate()
  const { user } = useAuth()

  const isFinanceOnly = useMemo(
    () => user?.user_type === 'finance' && !user?.is_staff && !user?.is_superuser,
    [user],
  )

  const visibleTabs = useMemo(() => {
    if (isFinanceOnly) {
      return TABS.filter((tab) => tab.id === 'payment-verification')
    }
    return TABS
  }, [isFinanceOnly])

  if (visibleTabs.length < 2) {
    return null
  }

  return (
    <div className="ux-segment" role="tablist" aria-label="Enrollment management sections" style={{ marginBottom: '1rem' }}>
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={active === tab.id ? 'is-active' : ''}
          onClick={() => navigate(tab.to)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default EnrollmentManagementTabs
